export const en = {
    languages: {
        cs: 'Czech',
        de: 'German',
        en: 'English',
        es: 'Spanish',
        fr: 'French',
        hr: 'Croatian',
        hu: 'Hungarian',
        it: 'Italian',
        nl: 'Dutch',
        pl: 'Polish',
        ru: 'Russian',
        sk: 'Slovak',
        tr: 'Turkish',
        uk: 'Ukrainian',
        undefined: 'No subtitles',
    },
    player: {
        content: {
            notFound: { title: 'Error while loading the media element 😞' },
        },
        controls: {
            backwards: { title: '10s backwards' },
            buffering: { title: 'Loading...' },
            captions: { title: 'Subtitles' },
            forwards: { title: '10s forwards' },
            fullscreen: { title: 'Fullscreen' },
            pause: { title: 'Pause' },
            play: { title: 'Play' },
            playlist: { title: 'Playlist' },
            volume: { title: 'Volume' },
        },
    },
};
